import { render, staticRenderFns } from "./SelectedPassportList.vue?vue&type=template&id=6d0d1b2a&"
import script from "./SelectedPassportList.vue?vue&type=script&lang=ts&"
export * from "./SelectedPassportList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports